import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class QuotationService {



       static generateQuotation(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.generateQuotation}`;
        return axiosInstance
            .post(api, data)
    }

    static sendQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.sendQuotation}`;
        return axiosInstance
            .post(api, data)

    }
        static resendQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.resendQuotation}`;
        return axiosInstance
            .post(api, data)

    }

        static recalculateQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.recalculateQuotation}`;
        return axiosInstance
            .post(api, data)

    }

     static editQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editQuotation}`;
        return axiosInstance
            .put(api, data)

    }

      static updatehotelQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updatehotelQuotation}`;
        return axiosInstance
            .post(api, data)

    }

      static updatevehicleQuotation(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.updatevehicleQuotation}`;
        return axiosInstance
            .post(api, data)

    }



      static updateferryQuotation(data) {
    
            let api = '';
            api = `${API_BASE_URL}${API_PATHS.updateferryQuotation}`;
            return axiosInstance
                .post(api, data)
    
        }

     static getQuotation(item) {
    
            let api = `${API_BASE_URL}${API_PATHS.getQuotation}`;
    
            const params = new URLSearchParams();
    
            if (item?.page) params.append("page", item.page);
            if (item?.limit) params.append("limit", item.limit);
            if (item?.id) params.append("id", item.id);
             if (item?.leadId) params.append("leadId", item.leadId);
           
            if ([...params].length > 0) {
                api += `?${params.toString()}`;
            }
    
            return axiosInstance.get(api);
        }


        static addBooking(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addBooking}`;
        return axiosInstance
            .post(api, data)
    }

     static getBookings(item) {
    
            let api = `${API_BASE_URL}${API_PATHS.getBookings}`;
    
            const params = new URLSearchParams();
    
            if (item?.page) params.append("page", item.page);
            if (item?.limit) params.append("limit", item.limit);
            if (item?.id) params.append("id", item.id);
             if (item?.leadId) params.append("leadId", item.leadId);
           
            if ([...params].length > 0) {
                api += `?${params.toString()}`;
            }
    
            return axiosInstance.get(api,item);
        }

   static addcustomerpayment(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addcustomerpayment}`;
        return axiosInstance
            .post(api, data)
    }
       static addvendorpayment(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addvendorpayment}`;
        return axiosInstance
            .post(api, data)
    }


       static deleteQuotation(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteQuotation}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default QuotationService;
